"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlusMinusWidget = void 0;
const PointerStateColorSet_1 = require("@nolimitcity/slot-launcher/bin/gui/buttons/states/sets/PointerStateColorSet");
const PointerStateIconSet_1 = require("@nolimitcity/slot-launcher/bin/gui/buttons/states/sets/PointerStateIconSet");
const Icon_1 = require("@nolimitcity/slot-launcher/bin/gui/displayobjects/Icon");
const PromoPanelAssetConfig_1 = require("../config/PromoPanelAssetConfig");
const IconToggleButton_1 = require("@nolimitcity/slot-launcher/bin/gui/buttons/IconToggleButton");
const ImgLoader_1 = require("@nolimitcity/slot-launcher/bin/loader/ImgLoader");
const PromoPanelConfig_1 = require("../config/PromoPanelConfig");
/**
 * Created by jonas on 2023-05-05.
 *
 * Small widget with - | + buttons. Used for changing bet.
 */
class PlusMinusWidget extends PIXI.Container {
    constructor(upButtonId, downButtonId, buttonCallback) {
        super();
        const colors = new PointerStateColorSet_1.PointerStateColorSet(0xffffffff);
        const upIcon = new PointerStateIconSet_1.PointerStateIconSet(new Icon_1.Icon(ImgLoader_1.ImgLoader.getImgTexture(PromoPanelAssetConfig_1.PromoPanelAssetConfig.BET_UP)));
        this._upButton = new IconToggleButton_1.IconToggleButton(upButtonId, upIcon, colors);
        this._upButton.addClickCallback(() => buttonCallback(this._upButton));
        this._upButton.toggled = false;
        this._upButton.pivot.set(38, 35);
        this._upButton.position.set(62, 0);
        const divider = new PIXI.Sprite(PIXI.Texture.WHITE);
        divider.width = 2;
        divider.height = 66;
        divider.anchor.set(0.5, 0.5);
        divider.alpha = 0.5;
        divider.roundPixels = true;
        const downIcon = new PointerStateIconSet_1.PointerStateIconSet(new Icon_1.Icon(ImgLoader_1.ImgLoader.getImgTexture(PromoPanelAssetConfig_1.PromoPanelAssetConfig.BET_DOWN)));
        this._downButton = new IconToggleButton_1.IconToggleButton(downButtonId, downIcon, colors);
        this._downButton.addClickCallback(() => buttonCallback(this._downButton));
        this._downButton.toggled = false;
        this._downButton.pivot.set(38, 35);
        this._downButton.position.set(-62, 0);
        this.addChild(this._upButton, divider, this._downButton);
    }
    enableUpButton(enable) {
        this._upButton.enable(enable);
        this._upButton.alpha = enable ? PromoPanelConfig_1.PromoPanelConfig.ENABLE_BTN_ALPHA : PromoPanelConfig_1.PromoPanelConfig.DISABLE_BTN_ALPHA;
    }
    enableDownButton(enable) {
        this._downButton.enable(enable);
        this._downButton.alpha = enable ? PromoPanelConfig_1.PromoPanelConfig.ENABLE_BTN_ALPHA : PromoPanelConfig_1.PromoPanelConfig.DISABLE_BTN_ALPHA;
    }
}
exports.PlusMinusWidget = PlusMinusWidget;
//# sourceMappingURL=PlusMinusWidget.js.map